// import { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { MdVerified } from 'react-icons/md';
// import { FiShoppingCart, FiPackage, FiTag, FiX } from 'react-icons/fi';
// import { IoHeartOutline, IoHeart } from 'react-icons/io5';
// import { FaLayerGroup } from 'react-icons/fa';
// import { useDispatch } from 'react-redux';
// import PlaceHolder from 'assets/placeholder.png';
// import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';
// import { useCurrency } from 'hooks/useCurrency';
// import { calculateProfit } from 'utils/utils';
// import { add_to_cart } from 'redux/actions/productActions';

// function resolveImg(item) {
//     if (!item?.cf_singleimage) return item?.image || PlaceHolder;
//     try {
//         const raw = item.cf_singleimage.trim();
//         if (raw.startsWith('http')) return raw;
//         const parsed = JSON.parse(raw);
//         return Array.isArray(parsed) ? parsed[0] || PlaceHolder : PlaceHolder;
//     } catch {
//         return item.cf_singleimage || item?.image || PlaceHolder;
//     }
// }

// function CartToast({ item, image, onClose }) {
//     useEffect(() => {
//         const t = setTimeout(onClose, 3200);
//         return () => clearTimeout(t);
//     }, [onClose]);

//     return (
//         <div style={toastS.wrap}>
//             <div style={toastS.bar} />
//             <img
//                 src={image}
//                 alt=""
//                 style={toastS.img}
//                 onError={(e) => {
//                     e.target.src = PlaceHolder;
//                 }}
//             />
//             <div style={toastS.text}>
//                 <p style={toastS.label}>Added to cart ✓</p>
//                 <p style={toastS.name}>{item?.item_name || item?.group_name || 'Product'}</p>
//             </div>
//             <button style={toastS.close} onClick={onClose}>
//                 <FiX size={13} />
//             </button>
//         </div>
//     );
// }

// function VariantsModal({ item, onClose, onAddToCart }) {
//     const variants = item?.variants ?? [];

//     return (
//         <div style={modalS.overlay} onClick={onClose}>
//             <div style={modalS.box} onClick={(e) => e.stopPropagation()}>
//                 <div style={modalS.header}>
//                     <div style={modalS.handle} />
//                     <div style={modalS.headerRow}>
//                         <div style={{ flex: 1, minWidth: 0 }}>
//                             {item?.brand && <p style={modalS.brand}>{item.brand}</p>}
//                             <h3 style={modalS.title}>{item?.group_name || item?.item_name}</h3>
//                             <p style={modalS.count}>
//                                 {variants.length} variant{variants.length !== 1 ? 's' : ''} — tap
//                                 one to add to cart
//                             </p>
//                         </div>
//                         <button style={modalS.closeBtn} onClick={onClose}>
//                             <FiX size={16} />
//                         </button>
//                     </div>
//                 </div>

//                 <div style={modalS.scrollArea}>
//                     <div style={modalS.grid}>
//                         {variants.map((v) => {
//                             const hasDiscount =
//                                 v?.has_discount === true && Number(v?.cf_discount_percentage) > 0;
//                             const discountPct = Number(v?.cf_discount_percentage) || 0;
//                             const img = resolveImg(v);
//                             const inStock = Number(v?.available_stock) > 0;

//                             return (
//                                 <div
//                                     key={v.item_id}
//                                     style={{ ...modalS.card, opacity: inStock ? 1 : 0.6 }}>
//                                     <div style={modalS.imgWrap}>
//                                         <img
//                                             src={img}
//                                             alt={v.item_name}
//                                             style={modalS.img}
//                                             onError={(e) => {
//                                                 e.target.src = PlaceHolder;
//                                             }}
//                                         />
//                                         {hasDiscount && (
//                                             <span style={modalS.discPill}>
//                                                 -{Math.round(discountPct)}%
//                                             </span>
//                                         )}
//                                         {!inStock && (
//                                             <div style={modalS.oosOverlay}>Out of Stock</div>
//                                         )}
//                                     </div>

//                                     <div style={modalS.info}>
//                                         <div style={modalS.tagRow}>
//                                             {v.color && (
//                                                 <span style={modalS.colorTag}>{v.color}</span>
//                                             )}
//                                             {v.size && <span style={modalS.sizeTag}>{v.size}</span>}
//                                         </div>

//                                         <p style={modalS.variantName}>{v.item_name}</p>

//                                         <p style={modalS.sku}>SKU: {v.sku}</p>

//                                         <div style={modalS.priceBlock}>
//                                             <span style={modalS.price}>
//                                                 <WalletHistoryPrice price={v.rate || 0} />
//                                             </span>
//                                             {hasDiscount && v.old_rate && (
//                                                 <span style={modalS.oldPrice}>
//                                                     <WalletHistoryPrice price={v.old_rate} />
//                                                 </span>
//                                             )}
//                                         </div>

//                                         {hasDiscount && (
//                                             <span style={modalS.savePill}>
//                                                 Save {Math.round(discountPct)}%
//                                             </span>
//                                         )}

//                                         <p
//                                             style={{
//                                                 ...modalS.stockText,
//                                                 color: inStock ? '#16A34A' : '#EF4444',
//                                             }}>
//                                             {inStock
//                                                 ? `✓ ${v.available_stock} in stock`
//                                                 : '✕ Out of stock'}
//                                         </p>

//                                         <button
//                                             disabled={!inStock}
//                                             style={{
//                                                 ...modalS.addBtn,
//                                                 background: inStock ? '#1B3B5F' : '#E2E8F0',
//                                                 color: inStock ? '#fff' : '#94A3B8',
//                                                 cursor: inStock ? 'pointer' : 'not-allowed',
//                                             }}
//                                             onClick={() => inStock && onAddToCart(v, img)}>
//                                             <FiShoppingCart size={11} style={{ marginRight: 4 }} />
//                                             {inStock ? 'Add to Cart' : 'Unavailable'}
//                                         </button>
//                                     </div>
//                                 </div>
//                             );
//                         })}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default function ProductItemNew({ item }) {
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const [wishlisted, setWishlisted] = useState(false);
//     const [imgError, setImgError] = useState(false);
//     const [showVariants, setShowVariants] = useState(false);
//     const [toast, setToast] = useState(null);
//     const [hovered, setHovered] = useState(false);

//     const itemRateConverted = useCurrency(item?.rate || 0);
//     const isGrouped = !!item?.group_id;
//     const image = imgError ? item?.image || PlaceHolder : resolveImg(item);

//     const hasDiscount = item?.has_discount === true && Number(item?.cf_discount_percentage) > 0;
//     const discountPct = Number(item?.cf_discount_percentage) || 0;
//     const isPreorder =
//         String(item?.cf_preorder ?? '')
//             .trim()
//             .toLowerCase() === 'yes';
//     const isClearance =
//         String(item?.cf_clearance_sale ?? '')
//             .trim()
//             .toLowerCase() === 'yes';
//     const isVerified = item?.cf_verified === 'Yes';
//     const isLimitedOffer = item?.cf_disable_date && item.cf_disable_date.trim() !== '';
//     const inStock = Number(item?.available_stock) > 0;
//     const variantCount = item?.variants?.length ?? 0;

//     const tag = isPreorder
//         ? { label: 'Pre-order', color: '#7C3AED', bg: '#EDE9FE' }
//         : isClearance
//         ? { label: 'Clearance', color: '#EA580C', bg: '#FFF7ED' }
//         : null;

//     const handleNavigate = () =>
//         navigate(
//             `/dashboard/product/details/${item.item_id}?slug=${encodeURIComponent(
//                 item?.cf_slug ?? '',
//             )}`,
//         );

//     const handleAddToCart = (productItem, productImage) => {
//         dispatch(add_to_cart({ productId: productItem.item_id, qty: 1 }));
//         setToast({ item: productItem, image: productImage || image });
//         setShowVariants(false);
//     };

//     const handleCartClick = (e) => {
//         e.stopPropagation();
//         if (isGrouped) setShowVariants(true);
//         else handleAddToCart(item, image);
//     };

//     return (
//         <>
//             <div
//                 style={{
//                     ...card.wrap,
//                     transform: hovered ? 'translateY(-3px)' : 'none',
//                     boxShadow: hovered
//                         ? '0 10px 28px rgba(11,89,213,0.12)'
//                         : '0 2px 8px rgba(0,0,0,0.05)',
//                 }}
//                 onMouseEnter={() => setHovered(true)}
//                 onMouseLeave={() => setHovered(false)}
//                 onClick={handleNavigate}>
//                 <div style={card.imgWrap}>
//                     <img
//                         src={image}
//                         alt={item?.item_name || 'Product'}
//                         style={{ ...card.img, transform: hovered ? 'scale(1.05)' : 'scale(1)' }}
//                         onError={() => setImgError(true)}
//                     />
//                     <div style={card.gradient} />

//                     <div style={card.badgeCol}>
//                         {tag && (
//                             <span style={{ ...card.pill, color: tag.color, background: tag.bg }}>
//                                 {tag.label}
//                             </span>
//                         )}
//                         {hasDiscount && (
//                             <span style={{ ...card.pill, color: '#DC2626', background: '#FEF2F2' }}>
//                                 -{Math.round(discountPct)}%
//                             </span>
//                         )}
//                         {isGrouped && (
//                             <span style={{ ...card.pill, color: '#0B59D5', background: '#EFF6FF' }}>
//                                 <FaLayerGroup size={7} style={{ marginRight: 2 }} />
//                                 {variantCount} variants
//                             </span>
//                         )}
//                     </div>

//                     <div style={card.actionCol}>
//                         <button
//                             style={card.iconBtn}
//                             onClick={handleCartClick}
//                             title={isGrouped ? 'Choose variant' : 'Add to cart'}>
//                             <FiShoppingCart size={12} />
//                         </button>
//                         <button
//                             style={{ ...card.iconBtn, color: wishlisted ? '#EF4444' : '#1B3B5F' }}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setWishlisted((v) => !v);
//                             }}>
//                             {wishlisted ? <IoHeart size={12} /> : <IoHeartOutline size={12} />}
//                         </button>
//                     </div>

//                     {isVerified && (
//                         <span style={card.verifiedChip}>
//                             <MdVerified size={10} /> Verified
//                         </span>
//                     )}
//                     {isLimitedOffer && <div style={card.dealBanner}>⚡ Deal Ending Soon</div>}
//                     {!inStock && !isGrouped && <div style={card.oosBanner}>Out of Stock</div>}
//                 </div>

//                 <div style={card.body}>
//                     <div style={card.metaRow}>
//                         {item?.brand && <span style={card.brand}>{item.brand}</span>}
//                         {item?.category_name && (
//                             <span style={card.category}>{item.category_name}</span>
//                         )}
//                     </div>
//                     <p style={card.name}>
//                         {isGrouped ? item.group_name ?? item.item_name : item.item_name}
//                     </p>
//                     <div style={card.skuRow}>
//                         <FiTag size={8} style={{ color: '#94A3B8', flexShrink: 0 }} />
//                         <span style={card.sku}>
//                             {item?.sku || (isGrouped ? `GRP-${item?.group_id?.slice(-6)}` : '—')}
//                         </span>
//                     </div>
//                     <div style={card.priceRow}>
//                         <span style={card.price}>
//                             <WalletHistoryPrice price={item?.rate || 0} />
//                         </span>
//                         {hasDiscount && item?.old_rate && (
//                             <span style={card.oldPrice}>
//                                 <WalletHistoryPrice price={item.old_rate} />
//                             </span>
//                         )}
//                     </div>
//                     <div style={card.chipsRow}>
//                         <span style={card.chip}>
//                             <FiPackage size={8} style={{ marginRight: 2 }} />
//                             {item?.unit === 'KG'
//                                 ? `${item?.weight || ''} ${item?.weight_unit || 'kg'}`
//                                 : `MOQ: ${item?.cf_moq ?? 1}`}
//                         </span>
//                         {!isGrouped && (
//                             <span
//                                 style={{
//                                     ...card.chip,
//                                     color: inStock ? '#16A34A' : '#EF4444',
//                                     background: inStock ? '#F0FDF4' : '#FEF2F2',
//                                 }}>
//                                 {inStock ? `${item.available_stock} left` : 'OOS'}
//                             </span>
//                         )}
//                     </div>
//                     <p style={card.profit}>
//                         {calculateProfit(item, itemRateConverted?.symbol, itemRateConverted?.price)}
//                     </p>
//                     {isGrouped ? (
//                         <button
//                             style={card.variantBtn}
//                             onClick={(e) => {
//                                 e.stopPropagation();
//                                 setShowVariants(true);
//                             }}>
//                             <FaLayerGroup size={10} style={{ marginRight: 4 }} />
//                             Choose Variant ({variantCount})
//                         </button>
//                     ) : (
//                         <button
//                             style={{
//                                 ...card.cartBtn,
//                                 background: inStock ? '#1B3B5F' : '#CBD5E1',
//                                 cursor: inStock ? 'pointer' : 'not-allowed',
//                             }}
//                             disabled={!inStock}
//                             onClick={handleCartClick}>
//                             <FiShoppingCart size={11} style={{ marginRight: 4 }} />
//                             {inStock ? 'Add to Cart' : 'Out of Stock'}
//                         </button>
//                     )}
//                 </div>
//             </div>

//             {showVariants && (
//                 <VariantsModal
//                     item={item}
//                     onClose={() => setShowVariants(false)}
//                     onAddToCart={handleAddToCart}
//                 />
//             )}
//             {toast && (
//                 <CartToast item={toast.item} image={toast.image} onClose={() => setToast(null)} />
//             )}
//         </>
//     );
// }

// const card = {
//     wrap: {
//         background: '#fff',
//         borderRadius: 12,
//         border: '1px solid #EEF2F7',
//         overflow: 'hidden',
//         cursor: 'pointer',
//         display: 'flex',
//         flexDirection: 'column',
//         transition: 'transform 0.2s ease, box-shadow 0.2s ease',
//         marginBottom: '1rem',
//     },
//     imgWrap: {
//         position: 'relative',
//         minWidth: 0,
//         width: '100%',
//         paddingTop: '82%',
//         background: '#F4F7FB',
//         overflow: 'hidden',
//     },
//     img: {
//         position: 'absolute',
//         inset: 0,
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//         transition: 'transform 0.45s cubic-bezier(0.34,1.56,0.64,1)',
//     },
//     gradient: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         right: 0,
//         height: '40%',
//         background: 'linear-gradient(to top,rgba(10,18,38,0.2),transparent)',
//         pointerEvents: 'none',
//     },
//     badgeCol: {
//         position: 'absolute',
//         top: 6,
//         left: 6,
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 3,
//     },
//     pill: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         fontSize: 8,
//         fontWeight: 700,
//         padding: '2px 5px',
//         borderRadius: 20,
//         letterSpacing: '0.02em',
//         whiteSpace: 'nowrap',
//     },
//     actionCol: {
//         position: 'absolute',
//         top: 6,
//         right: 6,
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 4,
//     },
//     iconBtn: {
//         width: 26,
//         height: 26,
//         borderRadius: '50%',
//         background: 'rgba(255,255,255,0.95)',
//         border: 'none',
//         cursor: 'pointer',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//         color: '#1B3B5F',
//     },
//     verifiedChip: {
//         position: 'absolute',
//         bottom: 6,
//         left: 6,
//         display: 'inline-flex',
//         alignItems: 'center',
//         gap: 2,
//         background: 'rgba(255,255,255,0.94)',
//         color: '#2563EB',
//         fontSize: 8,
//         fontWeight: 700,
//         padding: '2px 5px',
//         borderRadius: 20,
//     },
//     dealBanner: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         right: 0,
//         background: 'linear-gradient(90deg,#DC2626,#F97316)',
//         color: '#fff',
//         fontSize: 8,
//         fontWeight: 700,
//         textAlign: 'center',
//         padding: '3px 0',
//         letterSpacing: '0.03em',
//     },
//     oosBanner: {
//         position: 'absolute',
//         inset: 0,
//         background: 'rgba(248,250,252,0.7)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         fontSize: 10,
//         fontWeight: 700,
//         color: '#94A3B8',
//         backdropFilter: 'blur(2px)',
//     },
//     body: { padding: '9px 10px 11px', display: 'flex', flexDirection: 'column', gap: 3, flex: 1 },
//     metaRow: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 4 },
//     brand: {
//         fontSize: 8,
//         fontWeight: 700,
//         color: '#94A3B8',
//         textTransform: 'uppercase',
//         letterSpacing: '0.05em',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         whiteSpace: 'nowrap',
//     },
//     category: {
//         fontSize: 8,
//         fontWeight: 600,
//         color: '#0B59D5',
//         background: '#EFF6FF',
//         padding: '1px 5px',
//         borderRadius: 8,
//         whiteSpace: 'nowrap',
//         flexShrink: 0,
//     },
//     name: {
//         margin: 0,
//         fontSize: 11,
//         fontWeight: 700,
//         color: '#0F172A',
//         lineHeight: 1.35,
//         display: '-webkit-box',
//         WebkitLineClamp: 2,
//         WebkitBoxOrient: 'vertical',
//         overflow: 'hidden',
//     },
//     skuRow: { display: 'flex', alignItems: 'center', gap: 3 },
//     sku: {
//         fontSize: 8,
//         color: '#94A3B8',
//         fontFamily: 'monospace',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         whiteSpace: 'nowrap',
//     },
//     priceRow: { display: 'flex', alignItems: 'center', gap: 5, marginTop: 1, flexWrap: 'wrap' },
//     price: { fontSize: 13, fontWeight: 800, color: '#0B59D5' },
//     oldPrice: {
//         fontSize: 11,
//         fontWeight: 500,
//         color: '#94A3B8',
//         textDecoration: 'line-through',
//         textDecorationColor: '#EF4444',
//         textDecorationThickness: '1px',
//     },
//     chipsRow: { display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' },
//     chip: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         fontSize: 8,
//         fontWeight: 600,
//         color: '#475569',
//         background: '#F1F5F9',
//         padding: '2px 5px',
//         borderRadius: 8,
//     },
//     profit: { margin: 0, fontSize: 8, color: '#16A34A', fontWeight: 600 },
//     cartBtn: {
//         marginTop: 5,
//         width: '100%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '6px 0',
//         color: '#fff',
//         border: 'none',
//         borderRadius: 7,
//         fontSize: 10,
//         fontWeight: 700,
//         transition: 'opacity 0.15s',
//     },
//     variantBtn: {
//         marginTop: 5,
//         width: '100%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '6px 0',
//         background: 'transparent',
//         color: '#0B59D5',
//         border: '1.5px solid #0B59D5',
//         borderRadius: 7,
//         fontSize: 10,
//         fontWeight: 700,
//         cursor: 'pointer',
//     },
// };

// const modalS = {
//     overlay: {
//         position: 'fixed',
//         inset: 0,
//         background: 'rgba(10,18,38,0.6)',
//         zIndex: 5000,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backdropFilter: 'blur(5px)',
//         animation: 'fadeIn 0.2s ease',
//         padding: '12px',
//         // Ensure overlay itself doesn't scroll
//         overflow: 'hidden',
//     },
//     box: {
//         background: '#fff',
//         borderRadius: 20,
//         width: '100%',
//         maxWidth: 640,
//         // Fixed height so the grid scroll works properly
//         height: '90vh',
//         maxHeight: 680,
//         overflow: 'hidden',
//         display: 'flex',
//         flexDirection: 'column', // header fixed, grid scrolls
//         animation: 'scaleIn 0.25s cubic-bezier(0.34,1.56,0.64,1)',
//         boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
//     },
//     // Sticky non-scrolling header section
//     header: {
//         flexShrink: 0,
//         background: '#fff',
//         borderBottom: '1px solid #F1F5F9',
//         paddingBottom: 12,
//     },
//     handle: {
//         width: 36,
//         height: 4,
//         background: '#E2E8F0',
//         borderRadius: 4,
//         margin: '12px auto 0',
//     },
//     headerRow: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'flex-start',
//         padding: '10px 16px 0',
//         gap: 12,
//     },
//     brand: {
//         margin: 0,
//         fontSize: 9,
//         fontWeight: 700,
//         color: '#94A3B8',
//         textTransform: 'uppercase',
//         letterSpacing: '0.06em',
//     },
//     title: { margin: '2px 0', fontSize: 15, fontWeight: 800, color: '#0F172A', lineHeight: 1.3 },
//     count: { margin: 0, fontSize: 10, color: '#64748B' },
//     closeBtn: {
//         width: 30,
//         height: 30,
//         borderRadius: '50%',
//         background: '#F1F5F9',
//         border: 'none',
//         cursor: 'pointer',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         color: '#475569',
//         flexShrink: 0,
//     },
//     scrollArea: {
//         flex: 1,
//         overflowY: 'auto',
//         overflowX: 'hidden',
//         WebkitOverflowScrolling: 'touch',
//         scrollbarWidth: 'thin',
//         scrollbarColor: '#CBD5E1 transparent',
//     },
//     grid: {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
//         gap: 10,
//         padding: '12px 14px 20px',
//     },
//     card: {
//         background: '#FAFBFD',
//         borderRadius: 12,
//         border: '1px solid #EEF2F7',
//         overflow: 'hidden',
//         display: 'flex',
//         flexDirection: 'column',
//     },
//     imgWrap: {
//         position: 'relative',
//         width: '100%',
//         paddingTop: '52%',
//         background: '#F4F7FB',
//         overflow: 'hidden',
//         flexShrink: 0,
//     },
//     img: { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' },
//     discPill: {
//         position: 'absolute',
//         top: 4,
//         right: 4,
//         background: '#EF4444',
//         color: '#fff',
//         fontSize: 8,
//         fontWeight: 800,
//         padding: '2px 5px',
//         borderRadius: 10,
//     },
//     oosOverlay: {
//         position: 'absolute',
//         inset: 0,
//         background: 'rgba(255,255,255,0.65)',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         fontSize: 10,
//         fontWeight: 700,
//         color: '#94A3B8',
//         backdropFilter: 'blur(2px)',
//     },
//     info: {
//         padding: '7px 8px 9px',
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 4,
//         flex: 1,
//     },
//     tagRow: { display: 'flex', gap: 3, flexWrap: 'wrap' },
//     colorTag: {
//         fontSize: 9,
//         fontWeight: 700,
//         padding: '2px 6px',
//         background: '#F1F5F9',
//         color: '#475569',
//         borderRadius: 8,
//     },
//     sizeTag: {
//         fontSize: 9,
//         fontWeight: 700,
//         padding: '2px 6px',
//         background: '#EFF6FF',
//         color: '#0B59D5',
//         borderRadius: 8,
//     },
//     variantName: {
//         margin: 0,
//         fontSize: 10,
//         fontWeight: 600,
//         color: '#0F172A',
//         lineHeight: 1.3,
//         display: '-webkit-box',
//         WebkitLineClamp: 2,
//         WebkitBoxOrient: 'vertical',
//         overflow: 'hidden',
//     },
//     sku: {
//         margin: 0,
//         fontSize: 8,
//         color: '#94A3B8',
//         fontFamily: 'monospace',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         whiteSpace: 'nowrap',
//     },
//     priceBlock: { display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' },
//     price: { fontSize: 12, fontWeight: 800, color: '#0B59D5' },
//     oldPrice: {
//         fontSize: 10,
//         fontWeight: 500,
//         color: '#94A3B8',
//         textDecoration: 'line-through',
//         textDecorationColor: '#EF4444',
//         textDecorationThickness: '1px',
//     },
//     savePill: {
//         fontSize: 8,
//         fontWeight: 700,
//         color: '#DC2626',
//         background: '#FEF2F2',
//         padding: '1px 5px',
//         borderRadius: 8,
//     },
//     stockText: { margin: 0, fontSize: 9, fontWeight: 600 },
//     addBtn: {
//         marginTop: 'auto',
//         paddingTop: 4,
//         width: '100%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '7px 0',
//         border: 'none',
//         borderRadius: 8,
//         fontSize: 10,
//         fontWeight: 700,
//         transition: 'opacity 0.15s',
//     },
// };

// const toastS = {
//     wrap: {
//         position: 'fixed',
//         bottom: 24,
//         right: 24,
//         zIndex: 9999,
//         background: '#0F172A',
//         borderRadius: 12,
//         padding: '10px 12px 10px 10px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: 10,
//         boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
//         animation: 'slideUp 0.3s ease',
//         maxWidth: 270,
//         overflow: 'hidden',
//     },
//     bar: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         height: 3,
//         width: '100%',
//         background: 'linear-gradient(90deg,#0B59D5,#38BDF8)',
//         borderRadius: '0 0 12px 12px',
//         animation: 'shrink 3.2s linear forwards',
//     },
//     img: {
//         width: 38,
//         height: 38,
//         borderRadius: 7,
//         objectFit: 'cover',
//         flexShrink: 0,
//         border: '1.5px solid rgba(255,255,255,0.1)',
//     },
//     text: { flex: 1, minWidth: 0 },
//     label: {
//         margin: 0,
//         fontSize: 9,
//         fontWeight: 700,
//         color: '#38BDF8',
//         letterSpacing: '0.05em',
//         textTransform: 'uppercase',
//     },
//     name: {
//         margin: 0,
//         fontSize: 11,
//         fontWeight: 700,
//         color: '#fff',
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         whiteSpace: 'nowrap',
//     },
//     close: {
//         background: 'none',
//         border: 'none',
//         color: '#64748B',
//         cursor: 'pointer',
//         padding: 0,
//         display: 'flex',
//         flexShrink: 0,
//     },
// };
import { useMemo, useState, useCallback, memo } from 'react';
import {
    Box,
    Flex,
    Text,
    Button,
    IconButton,
    Image,
    Badge,
    Skeleton,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    ModalCloseButton,
    Heading,
    SimpleGrid,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import PlaceHolder from 'assets/placeholder.png';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';
import { useCurrency } from 'hooks/useCurrency';
import { calculateProfit } from 'utils/utils';
import { add_to_cart } from 'redux/actions/productActions';
import {
    add_to_wishlist,
    remove_from_wishlist,
} from 'redux/actions/wishActions';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */

const NAVY        = '#1B3B5F';
const NAVY_DEEP   = '#0F2940';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';

const SUCCESS     = '#10B981';
const SUCCESS_BG  = '#ECFDF5';
const DANGER      = '#E53E3E';
const DANGER_BG   = '#FEF2F2';
const WARNING     = '#EA580C';
const WARNING_BG  = '#FFF7ED';
const PURPLE      = '#7C3AED';
const PURPLE_BG   = '#EDE9FE';

const FONT = "'Bricolage Grotesque', sans-serif";

const SHADOW_SM = '0 1px 3px rgba(27,59,95,0.06)';
const SHADOW_MD = '0 10px 28px rgba(27,59,95,0.10)';

/* ─────────────────────────────────────────────────────────────
   IMAGE RESOLVER
   ───────────────────────────────────────────────────────────── */

const resolveImg = (item) => {
    if (!item?.cf_singleimage) return item?.image || PlaceHolder;
    try {
        const raw = item.cf_singleimage.trim();
        if (raw.startsWith('http')) return raw;
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed[0] || PlaceHolder : PlaceHolder;
    } catch {
        return item.cf_singleimage || item?.image || PlaceHolder;
    }
};

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */

const CartIcon = (props) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M3 4h2l2.4 12.2a2 2 0 002 1.8h8.7a2 2 0 002-1.6L22 8H6"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="10" cy="21" r="1.5" fill="currentColor" />
        <circle cx="18" cy="21" r="1.5" fill="currentColor" />
    </svg>
);

const HeartIcon = ({ filled, ...props }) =>
    filled ? (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" {...props}>
            <path d="M12 21s-7-4.5-9.5-9C.9 8.8 2 5.5 5 4.5c2-.7 4 .3 5 2 1-1.7 3-2.7 5-2 3 1 4.1 4.3 2.5 7.5C19 16.5 12 21 12 21z" />
        </svg>
    ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M12 21s-7-4.5-9.5-9C.9 8.8 2 5.5 5 4.5c2-.7 4 .3 5 2 1-1.7 3-2.7 5-2 3 1 4.1 4.3 2.5 7.5C19 16.5 12 21 12 21z"
                stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
    );

const LayersIcon = (props) => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
    </svg>
);

const PackageIcon = (props) => (
    <svg width="9" height="9" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5M21 8v8l-9 5"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const VerifiedIcon = (props) => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M12 2l3 3 4-.5L20 9l3 3-3 3-1 4.5-4-.5L12 22l-3-3-4 .5L4 15l-3-3 3-3 1-4.5L9 5l3-3zm-1 13l6-6-1.4-1.4-4.6 4.6-2.6-2.6L7 11l4 4z" />
    </svg>
);

const FlashIcon = (props) => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" {...props}>
        <path d="M13 2L4.09 12.97a.5.5 0 00.4.78H11l-1 8.25 8.91-10.97a.5.5 0 00-.4-.78H13L13 2z" />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   CARD SKELETON (exported for grids)
   ───────────────────────────────────────────────────────────── */

export const ProductCardSkeleton = memo(function ProductCardSkeleton() {
    return (
        <Box
            bg={SURFACE}
            borderRadius="12px"
            border="1px solid"
            borderColor={BORDER}
            overflow="hidden"
            boxShadow={SHADOW_SM}
        >
            <Skeleton paddingTop="75%" startColor={SURFACE_ALT} endColor={BORDER} />
            <Box p="10px">
                <Skeleton h="3" w="40%" mb="2" startColor={SURFACE_ALT} endColor={BORDER} />
                <Skeleton h="3" w="80%" mb="2" startColor={SURFACE_ALT} endColor={BORDER} />
                <Skeleton h="3" w="60%" mb="3" startColor={SURFACE_ALT} endColor={BORDER} />
                <Skeleton h="5" w="50%" mb="3" startColor={SURFACE_ALT} endColor={BORDER} />
                <Skeleton h="34px" w="full" borderRadius="7px" startColor={SURFACE_ALT} endColor={BORDER} />
            </Box>
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   STATUS PILL (corner badges)
   ───────────────────────────────────────────────────────────── */

const StatusPill = memo(function StatusPill({ icon: Icon, label, color, bg, ...rest }) {
    return (
        <Flex
            align="center"
            gap="3px"
            px="6px"
            py="2px"
            borderRadius="full"
            bg={bg}
            color={color}
            fontSize="9px"
            fontWeight="800"
            fontFamily={FONT}
            letterSpacing="0.02em"
            whiteSpace="nowrap"
            border={`1px solid ${color}20`}
            {...rest}
        >
            {Icon && <Icon />}
            <Text as="span">{label}</Text>
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   VARIANTS MODAL (Chakra UI)
   ───────────────────────────────────────────────────────────── */

const VariantsModal = memo(function VariantsModal({ item, isOpen, onClose, onPick }) {
    const variants = item?.variants ?? [];
    return (
        <Modal isOpen={isOpen} onClose={onClose} size={{ base: 'full', md: 'xl' }} scrollBehavior="inside">
            <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
            <ModalContent
                borderRadius={{ base: '0', md: '16px' }}
                bg={SURFACE}
                fontFamily={FONT}
                maxH={{ base: '100vh', md: '85vh' }}
            >
                <Box p="20px 20px 14px" borderBottom="1px solid" borderColor={BORDER}>
                    {item?.brand && (
                        <Text fontSize="9px" fontWeight="800" color={FAINT} letterSpacing="0.08em" textTransform="uppercase" mb="2px">
                            {item.brand}
                        </Text>
                    )}
                    <Heading as="h3" fontSize="16px" fontWeight="800" color={INK} fontFamily={FONT} pr="40px">
                        {item?.group_name || item?.item_name}
                    </Heading>
                    <Text fontSize="11px" color={MUTED} mt="2px">
                        {variants.length} variant{variants.length !== 1 ? 's' : ''} — tap one to add to cart
                    </Text>
                    <ModalCloseButton color={MUTED} _hover={{ bg: SURFACE_ALT, color: INK }} top="14px" right="14px" />
                </Box>

                <ModalBody p="14px 16px 20px">
                    {variants.length === 0 ? (
                        <Flex direction="column" align="center" py="40px" gap="8px">
                            <Text fontSize="13px" fontWeight="700" color={INK}>No variants available</Text>
                            <Text fontSize="11px" color={FAINT} textAlign="center">
                                This product doesn't have variants right now.
                            </Text>
                        </Flex>
                    ) : (
                        <SimpleGrid columns={{ base: 2, sm: 3 }} spacing="10px">
                            {variants.map((v) => {
                                const img = resolveImg(v);
                                const inStock = Number(v?.available_stock) > 0;
                                const hasDisc = v?.has_discount && Number(v?.cf_discount_percentage) > 0;
                                const discPct = Number(v?.cf_discount_percentage) || 0;

                                return (
                                    <Box
                                        key={v.item_id}
                                        bg={SURFACE_ALT}
                                        borderRadius="10px"
                                        border="1px solid"
                                        borderColor={BORDER}
                                        overflow="hidden"
                                        opacity={inStock ? 1 : 0.55}
                                    >
                                        <Box position="relative" pt="80%" bg={SURFACE}>
                                            <Image
                                                src={img}
                                                alt={v.item_name}
                                                position="absolute"
                                                inset="0"
                                                w="full"
                                                h="full"
                                                objectFit="cover"
                                                fallbackSrc={PlaceHolder}
                                            />
                                            {hasDisc && (
                                                <Badge
                                                    position="absolute"
                                                    top="6px"
                                                    right="6px"
                                                    bg={DANGER}
                                                    color="white"
                                                    fontSize="9px"
                                                    fontWeight="800"
                                                    px="6px"
                                                    py="1px"
                                                    borderRadius="full"
                                                >
                                                    -{Math.round(discPct)}%
                                                </Badge>
                                            )}
                                            {!inStock && (
                                                <Flex
                                                    position="absolute"
                                                    inset="0"
                                                    align="center"
                                                    justify="center"
                                                    bg="whiteAlpha.700"
                                                    color={MUTED}
                                                    fontSize="11px"
                                                    fontWeight="700"
                                                >
                                                    Out of stock
                                                </Flex>
                                            )}
                                        </Box>
                                        <Box p="8px 10px 10px">
                                            <Flex gap="4px" flexWrap="wrap" mb="4px">
                                                {v.color && (
                                                    <Badge bg={SURFACE} color={MUTED} fontSize="9px" px="6px" py="1px" border="1px solid" borderColor={BORDER}>
                                                        {v.color}
                                                    </Badge>
                                                )}
                                                {v.size && (
                                                    <Badge bg={CYAN} color={NAVY} fontSize="9px" px="6px" py="1px" fontWeight="800">
                                                        {v.size}
                                                    </Badge>
                                                )}
                                            </Flex>
                                            <Text fontSize="11px" fontWeight="600" color={INK} noOfLines={2} lineHeight="1.3" mb="3px">
                                                {v.item_name}
                                            </Text>
                                            <Flex align="baseline" gap="6px" mb="6px" flexWrap="wrap">
                                                <Text fontSize="12px" fontWeight="800" color={NAVY}>
                                                    <WalletHistoryPrice price={v.rate || 0} />
                                                </Text>
                                                {hasDisc && v.old_rate && (
                                                    <Text fontSize="10px" color={FAINT} textDecoration="line-through">
                                                        <WalletHistoryPrice price={v.old_rate} />
                                                    </Text>
                                                )}
                                            </Flex>
                                            <Text fontSize="10px" color={inStock ? SUCCESS : DANGER} fontWeight="700" mb="6px">
                                                {inStock ? `${v.available_stock} in stock` : 'Unavailable'}
                                            </Text>
                                            <Button
                                                onClick={() => inStock && onPick(v, img)}
                                                isDisabled={!inStock}
                                                w="full"
                                                size="xs"
                                                h="30px"
                                                bg={inStock ? NAVY : BORDER}
                                                color={inStock ? 'white' : FAINT}
                                                _hover={{ bg: inStock ? NAVY_DEEP : BORDER }}
                                                _active={{ bg: NAVY_DEEP }}
                                                fontSize="10px"
                                                fontWeight="700"
                                                borderRadius="6px"
                                                leftIcon={<CartIcon />}
                                            >
                                                {inStock ? 'Add to cart' : 'Sold out'}
                                            </Button>
                                        </Box>
                                    </Box>
                                );
                            })}
                        </SimpleGrid>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
});

/* ─────────────────────────────────────────────────────────────
   MAIN PRODUCT CARD
   ───────────────────────────────────────────────────────────── */

function ProductItemNew({ item, onAddToCart }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showVariants, setShowVariants] = useState(false);

    const wishlistItems = useSelector((s) => s.wishReducer?.products?.items ?? []);
    const wishlistAdding = useSelector((s) => s.wishReducer?.adding ?? false);

    const isWishlisted = useMemo(() => {
        if (!item?.item_id || !Array.isArray(wishlistItems)) return false;
        return wishlistItems.some(
            (w) =>
                w?.id === item.item_id ||
                w?.item_id === item.item_id ||
                w?.productId === item.item_id
        );
    }, [wishlistItems, item?.item_id]);

    const itemRateConverted = useCurrency(item?.rate || 0);
    const image = resolveImg(item);
    const isGrouped = !!item?.group_id;
    const variantCount = item?.variants?.length ?? 0;
    const inStock = Number(item?.available_stock) > 0;

    const hasDiscount = item?.has_discount === true && Number(item?.cf_discount_percentage) > 0;
    const discountPct = Number(item?.cf_discount_percentage) || 0;

    const isPreorder = String(item?.cf_preorder ?? '').trim().toLowerCase() === 'yes';
    const isClearance = String(item?.cf_clearance_sale ?? '').trim().toLowerCase() === 'yes';
    const isVerified = item?.cf_verified === 'Yes';
    const isLimitedOffer = item?.cf_disable_date && String(item.cf_disable_date).trim() !== '';

    const statusPill = isPreorder
        ? { label: 'Pre-order', color: PURPLE, bg: PURPLE_BG }
        : isClearance
        ? { label: 'Clearance', color: WARNING, bg: WARNING_BG }
        : null;

    const displayName = isGrouped ? item?.group_name ?? item?.item_name : item?.item_name;
    const displaySku = item?.sku ?? (isGrouped ? `GRP-${item?.group_id?.slice(-6)}` : '—');

    const handleNavigate = useCallback(() => {
        navigate(
            `/dashboard/product/details/${item.item_id}?slug=${encodeURIComponent(
                item?.cf_slug ?? ''
            )}`
        );
    }, [navigate, item?.item_id, item?.cf_slug]);

    const handleAddToCart = useCallback(
        (e) => {
            e.stopPropagation();
            if (isGrouped) {
                setShowVariants(true);
                return;
            }
            if (typeof onAddToCart === 'function') {
                onAddToCart(item);
            } else {
                dispatch(add_to_cart({ productId: item.item_id, qty: 1 }));
            }
        },
        [isGrouped, onAddToCart, dispatch, item]
    );

    const handleVariantPick = useCallback(
        (variant) => {
            if (typeof onAddToCart === 'function') {
                onAddToCart(variant);
            } else {
                dispatch(add_to_cart({ productId: variant.item_id, qty: 1 }));
            }
            setShowVariants(false);
        },
        [onAddToCart, dispatch]
    );

    const handleWishlistToggle = useCallback(
        (e) => {
            e.stopPropagation();
            if (wishlistAdding) return;
            if (isWishlisted) {
                dispatch(remove_from_wishlist(item.item_id));
            } else {
                dispatch(add_to_wishlist(item));
            }
        },
        [isWishlisted, wishlistAdding, dispatch, item]
    );

    return (
        <>
            <Box
                bg={SURFACE}
                borderRadius="12px"
                border="1px solid"
                borderColor={BORDER}
                overflow="hidden"
                cursor="pointer"
                display="flex"
                flexDirection="column"
                transition="transform 0.2s ease, box-shadow 0.2s ease"
                boxShadow={SHADOW_SM}
                _hover={{
                    transform: 'translateY(-3px)',
                    boxShadow: SHADOW_MD,
                    '& .product-img': { transform: 'scale(1.05)' },
                }}
                onClick={handleNavigate}
                role="article"
                aria-label={displayName}
                minW="0"
                w="full"
            >
                {/* IMAGE AREA */}
                <Box position="relative" w="full" pt="75%" bg={SURFACE_ALT} overflow="hidden">
                    <Image
                        src={image}
                        alt={displayName || 'Product'}
                        position="absolute"
                        inset="0"
                        w="full"
                        h="full"
                        objectFit="cover"
                        loading="lazy"
                        fallbackSrc={PlaceHolder}
                        className="product-img"
                        transition="transform 0.45s cubic-bezier(0.34,1.56,0.64,1)"
                        filter={!inStock && !isGrouped ? 'grayscale(0.6)' : 'none'}
                    />

                    <Box
                        position="absolute"
                        bottom="0"
                        left="0"
                        right="0"
                        h="40%"
                        bgGradient="linear(to-t, blackAlpha.300, transparent)"
                        pointerEvents="none"
                    />

                    <Flex position="absolute" top="6px" left="6px" direction="column" gap="3px" zIndex={2} pointerEvents="none">
                        {statusPill && <StatusPill label={statusPill.label} color={statusPill.color} bg={statusPill.bg} />}
                        {hasDiscount && <StatusPill label={`-${Math.round(discountPct)}%`} color={DANGER} bg={DANGER_BG} />}
                        {isGrouped && <StatusPill icon={LayersIcon} label={`${variantCount} variants`} color={NAVY} bg={CYAN} />}
                    </Flex>

                    <Flex position="absolute" top="6px" right="6px" direction="column" gap="4px" zIndex={2}>
                        <IconButton
                            aria-label={isGrouped ? 'Choose variant' : 'Add to cart'}
                            icon={<CartIcon />}
                            onClick={handleAddToCart}
                            size="xs"
                            w="28px"
                            h="28px"
                            minW="28px"
                            borderRadius="full"
                            bg="whiteAlpha.900"
                            color={NAVY}
                            boxShadow="0 2px 6px rgba(0,0,0,0.12)"
                            _hover={{ bg: 'white', color: NAVY_DEEP, transform: 'scale(1.08)' }}
                            _active={{ transform: 'scale(0.95)' }}
                            transition="all 0.15s ease"
                        />
                        <IconButton
                            aria-label={isWishlisted ? 'Remove from wishlist' : 'Add to wishlist'}
                            aria-pressed={isWishlisted}
                            icon={<HeartIcon filled={isWishlisted} />}
                            onClick={handleWishlistToggle}
                            isLoading={wishlistAdding}
                            size="xs"
                            w="28px"
                            h="28px"
                            minW="28px"
                            borderRadius="full"
                            bg="whiteAlpha.900"
                            color={isWishlisted ? DANGER : NAVY}
                            boxShadow="0 2px 6px rgba(0,0,0,0.12)"
                            _hover={{ bg: 'white', color: isWishlisted ? DANGER : DANGER, transform: 'scale(1.08)' }}
                            _active={{ transform: 'scale(0.95)' }}
                            transition="all 0.15s ease"
                        />
                    </Flex>

                    {isVerified && (
                        <Flex
                            position="absolute"
                            bottom="6px"
                            left="6px"
                            align="center"
                            gap="3px"
                            bg="whiteAlpha.950"
                            color={NAVY}
                            fontSize="9px"
                            fontWeight="800"
                            px="6px"
                            py="2px"
                            borderRadius="full"
                            boxShadow="0 1px 3px rgba(0,0,0,0.1)"
                            zIndex={2}
                        >
                            <VerifiedIcon />
                            <Text as="span">Verified</Text>
                        </Flex>
                    )}

                    {isLimitedOffer && (
                        <Flex
                            position="absolute"
                            bottom="6px"
                            right="6px"
                            align="center"
                            gap="3px"
                            bgGradient="linear(90deg, #DC2626, #F97316)"
                            color="white"
                            fontSize="9px"
                            fontWeight="800"
                            px="6px"
                            py="2px"
                            borderRadius="full"
                            boxShadow="0 1px 3px rgba(0,0,0,0.2)"
                            zIndex={2}
                            letterSpacing="0.03em"
                        >
                            <FlashIcon />
                            <Text as="span">Deal ending</Text>
                        </Flex>
                    )}

                    {!inStock && !isGrouped && (
                        <Flex
                            position="absolute"
                            top="50%"
                            left="50%"
                            transform="translate(-50%, -50%)"
                            bg="blackAlpha.700"
                            color="white"
                            fontSize="10px"
                            fontWeight="800"
                            px="10px"
                            py="4px"
                            borderRadius="full"
                            letterSpacing="0.05em"
                            textTransform="uppercase"
                            zIndex={2}
                        >
                            Sold out
                        </Flex>
                    )}
                </Box>

                {/* BODY */}
                <Flex direction="column" p="8px 9px 10px" gap="3px" flex="1">
                    <Flex align="center" justify="space-between" gap="6px" minW="0">
                        {item?.brand && (
                            <Text
                                fontSize="9px"
                                fontWeight="800"
                                color={FAINT}
                                textTransform="uppercase"
                                letterSpacing="0.05em"
                                noOfLines={1}
                                flex="1"
                                minW="0"
                            >
                                {item.brand}
                            </Text>
                        )}
                        {item?.category_name && (
                            <Text
                                fontSize="9px"
                                fontWeight="700"
                                color={NAVY}
                                bg={CYAN}
                                px="6px"
                                py="1px"
                                borderRadius="full"
                                noOfLines={1}
                                maxW="60%"
                            >
                                {item.category_name}
                            </Text>
                        )}
                    </Flex>

                    <Text
                        fontSize="12px"
                        fontWeight="700"
                        color={INK}
                        lineHeight="1.3"
                        fontFamily={FONT}
                        noOfLines={1}
                    >
                        {displayName}
                    </Text>

                    <Text
                        fontSize="9px"
                        color={FAINT}
                        fontFamily="monospace"
                        noOfLines={1}
                        display={{ base: 'none', md: 'block' }}
                    >
                        {displaySku}
                    </Text>

                    <Flex align="baseline" gap="6px" mt="2px" flexWrap="wrap">
                        <Text fontSize="14px" fontWeight="800" color={NAVY} fontFamily={FONT}>
                            <WalletHistoryPrice price={item?.rate || 0} />
                        </Text>
                        {hasDiscount && item?.old_rate && (
                            <Text fontSize="11px" fontWeight="500" color={FAINT} textDecoration="line-through">
                                <WalletHistoryPrice price={item.old_rate} />
                            </Text>
                        )}
                    </Flex>

                    <Flex align="center" gap="4px" flexWrap="wrap" mt="2px">
                        <Flex
                            align="center"
                            gap="3px"
                            bg={SURFACE_ALT}
                            color={MUTED}
                            fontSize="9px"
                            fontWeight="700"
                            px="6px"
                            py="2px"
                            borderRadius="full"
                            border="1px solid"
                            borderColor={BORDER}
                        >
                            <PackageIcon />
                            <Text as="span">
                                {item?.unit === 'KG'
                                    ? `${item?.weight || ''} ${item?.weight_unit || 'kg'}`
                                    : `MOQ: ${item?.cf_moq ?? 1}`}
                            </Text>
                        </Flex>
                        {!isGrouped && (
                            <Text
                                fontSize="9px"
                                fontWeight="700"
                                color={inStock ? SUCCESS : DANGER}
                                bg={inStock ? SUCCESS_BG : DANGER_BG}
                                px="6px"
                                py="2px"
                                borderRadius="full"
                                border="1px solid"
                                borderColor={inStock ? `${SUCCESS}30` : `${DANGER}30`}
                                display={{ base: 'none', sm: 'inline-flex' }}
                            >
                                {inStock ? `${item.available_stock} left` : 'OOS'}
                            </Text>
                        )}
                    </Flex>

                    <Text
                        fontSize="9px"
                        fontWeight="700"
                        color={SUCCESS}
                        mt="1px"
                        noOfLines={1}
                        display={{ base: 'none', md: 'block' }}
                    >
                        {calculateProfit(item, itemRateConverted?.symbol, itemRateConverted?.price)}
                    </Text>

                    {isGrouped ? (
                        <Button
                            mt="6px"
                            w="full"
                            h={{ base: '32px', md: '36px' }}
                            variant="outline"
                            borderColor={NAVY}
                            color={NAVY}
                            bg="transparent"
                            _hover={{ bg: CYAN, borderColor: NAVY_DEEP }}
                            _active={{ bg: CYAN }}
                            onClick={(e) => { e.stopPropagation(); setShowVariants(true); }}
                            fontSize={{ base: '10px', md: '11px' }}
                            fontWeight="700"
                            fontFamily={FONT}
                            borderRadius="8px"
                            leftIcon={<LayersIcon />}
                            px="6px"
                            sx={{
                                '& .desktop-label': { display: { base: 'none', sm: 'inline' } },
                                '& .mobile-label': { display: { base: 'inline', sm: 'none' } },
                            }}
                        >
                            <Text as="span" className="mobile-label">Variants ({variantCount})</Text>
                            <Text as="span" className="desktop-label">Choose Variant ({variantCount})</Text>
                        </Button>
                    ) : (
                        <Button
                            mt="6px"
                            w="full"
                            h={{ base: '32px', md: '36px' }}
                            bg={inStock ? NAVY : BORDER}
                            color={inStock ? 'white' : FAINT}
                            _hover={{ bg: inStock ? NAVY_DEEP : BORDER }}
                            _active={{ bg: NAVY_DEEP }}
                            _disabled={{ bg: BORDER, color: FAINT, cursor: 'not-allowed', _hover: { bg: BORDER } }}
                            isDisabled={!inStock}
                            onClick={handleAddToCart}
                            fontSize={{ base: '10px', md: '11px' }}
                            fontWeight="700"
                            fontFamily={FONT}
                            borderRadius="8px"
                            leftIcon={<CartIcon />}
                            px="6px"
                            aria-label={inStock ? `Add ${displayName} to cart` : 'Out of stock'}
                            sx={{
                                '& .desktop-label': { display: { base: 'none', sm: 'inline' } },
                                '& .mobile-label': { display: { base: 'inline', sm: 'none' } },
                            }}
                        >
                            <Text as="span" className="mobile-label">{inStock ? 'Add' : 'Sold out'}</Text>
                            <Text as="span" className="desktop-label">{inStock ? 'Add to cart' : 'Out of stock'}</Text>
                        </Button>
                    )}
                </Flex>
            </Box>

            <VariantsModal
                item={item}
                isOpen={showVariants}
                onClose={() => setShowVariants(false)}
                onPick={handleVariantPick}
            />
        </>
    );
}

export default memo(ProductItemNew);